// extracted by mini-css-extract-plugin
export default {"task-confirmatory":"styles_task-confirmatory__Oiu0e"};